import { createContext, useContext } from 'react';
import { DnDToken, Flow, SlotCapacity } from '@/utils/questions/dnd/types';
import { FlipOrigin } from '@/hooks/questions/dnd/usePlacementFlip';

export type Helpers = {
  tokensOf: (slotId: string) => DnDToken[];
  capacityOf: (slotId: string) => SlotCapacity;
  getToken: (id: string) => DnDToken | undefined;
};

type Animations = {
  flipFrom: Record<string, FlipOrigin>;
  clearFlip: (id: string) => void;
};

type ClickManagement = {
  selectedId: string | null;
  clearSelection: () => void;
  onChipClick: (chipId: string) => void;
  onContainerClick: (containerId: string) => void;
};

export type DragDropAnswerContextValue = Helpers &
  Animations &
  ClickManagement & {
    bankTokens: DnDToken[];
    disabled: boolean;
    flow?: Flow;
  };

export const DragDropAnswerContext =
  createContext<DragDropAnswerContextValue | null>(null);

export function useDragDropAnswerContext() {
  const context = useContext(DragDropAnswerContext);
  if (!context) {
    throw new Error('DnD kit components must be used within <DragDropAnswer>');
  }
  return context;
}
